var html = document.documentElement;
var body = document.body;
var timeout;
var st = 0;

timer();
setInterval(timer, 60000); // 60000 milliseconds = 1 minute
handleVideoPlayback();
footerGroup();

// Call functions when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        categoryNav();
        removeProductCardAttributes();
        randomizeAvatarImages();
        addDocumentationLinkIcons();
    });
} else {
    categoryNav();
    removeProductCardAttributes();
    randomizeAvatarImages();
    addDocumentationLinkIcons();
}

window.addEventListener('scroll', function () {
    'use strict';
    if (body.classList.contains('home-template') && body.classList.contains('with-full-cover') && !document.querySelector('.cover').classList.contains('half')) {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(portalButton);
    }
});

if (document.querySelector('.cover') && document.querySelector('.cover').classList.contains('half')) {
    body.classList.add('portal-visible');
}

pagination();

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function timer() {
    // Get the current time in Singapore
    const singaporeTime = new Date().toLocaleString("en-US", {timeZone: "Asia/Singapore"});
    const time = new Date(singaporeTime);
    const hour = time.getHours();
    const minute = time.getMinutes();

    // Format the time
    const ampm = hour >= 12 ? 'pm' : 'am';
    const formattedHour = hour % 12 || 12; // Convert hour to 12-hour format
    const formattedTime = `${formattedHour}:${minute < 10 ? '0' + minute : minute} ${ampm}`;

    // Update the time display and the "working" text
    document.getElementById("current-time").textContent = `${formattedTime}`;

    const workStatusElement = document.getElementById("work-status");

    // Check if the current time is within working hours (9am - 5pm)
    const isWorkingHours = hour >= 10 && hour < 20;

    workStatusElement.textContent = !isWorkingHours ? "Currently 😴" : "Currently working 👋";

    workStatusElement.classList.toggle("sleeping", !isWorkingHours);
}

function footerGroup() {
    const footerNav = document.querySelector(".footer-right");
    const items = document.querySelectorAll(".footer-right .nav li");

    const groups = [];
    let index = null;
    items.forEach(item => {
        const text = item.textContent.trim();
        const PREFIXFOOTERHEADER = "#";
        if (text.includes(PREFIXFOOTERHEADER)) {
            index = index === null ? 0 : ++index;
            groups[index] = { header: "", items: [] };
            groups[index].header = text.slice(PREFIXFOOTERHEADER.length);
        } else {
            const classNames = Array.from(item.classList).join(" ");
            groups[index].items.push({ text, link: item.childNodes[0].href, classNames });
        }
    })
    document.querySelector(".footer-right ul.nav").remove();
    groups.forEach((group) => {
        const div = document.createElement('div');
        const h6 = document.createElement('h6');
        h6.classList.add("footer-group-header");
        h6.innerHTML = group.header;
        const ul = document.createElement("ul");
        ul.classList.add("nav");
        group.items.forEach((item) => {
            const li = document.createElement("li");
            li.innerHTML = `<a href="${item.link}" class="${item.classNames}">${item.text}</a>`;
            // li.classList.add(item.classNames);
            ul.append(li);
        })
        div.append(h6, ul);
        footerNav.appendChild(div);
    });
}

function handleVideoPlayback() {
    const options = {
        root: null,
        rootMargin: '2px',
        threshold: [0, 0.5, 1]  // We'll observe at 0%, 25%, and 100% visibility
    };

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            const video = entry.target;
            
            if (entry.intersectionRatio >= 0.5) {
                // Load the video only when it's about to be played
                if (video.preload === 'none') {
                    video.preload = 'auto';
                }
                if (video.paused) {
                    // Only play if the video has loaded
                    if (video.readyState >= 3) {
                        video.play().catch(error => console.error('Error playing video:', error));
                    } else {
                        video.addEventListener('canplay', () => {
                            video.play().catch(error => console.error('Error playing video:', error));
                        }, { once: true });
                    }
                }
            } else if (entry.intersectionRatio === 0) {
                // The video is completely out of the viewport
                if (!video.paused) {
                    video.pause();
                }
            } else if (entry.intersectionRatio < 0.5) {
                // The video is less than 25% in the viewport
                if (!video.paused) {
                    video.pause();
                }
            }
        });
    }, options);

    // Add loading handler for each video
    const videos = document.querySelectorAll('video.preload-video');
    videos.forEach(video => {
        observer.observe(video);
        
        // Add error handling
        video.addEventListener('error', (e) => {
            console.error('Video loading error:', e);
            video.style.display = 'none'; // Hide video on error, showing poster/background
        });
    });
}

function categoryNav() {
    var currentPageURL = window.location.pathname;

    // Get all <a> tags inside the .blog-navbar div
    var navbarLinks = document.querySelectorAll('.blog-navbar a');

    // Loop through each <a> tag
    navbarLinks.forEach(function(link) {
        // Check if the href attribute matches the current page URL
        if (link.getAttribute('href') === currentPageURL) {
            // Add the is-active class
            link.classList.add('is-active');
        }
    });
}

// Function to remove target and rel attributes from product card buttons
function removeProductCardAttributes() {
    const productCardButtons = document.querySelectorAll('.product-cards .kg-product-card-button');
    productCardButtons.forEach(button => {
        button.removeAttribute('target');
        button.removeAttribute('rel');
    });
}

// Function to randomize avatar images order
function randomizeAvatarImages() {
    const avatarContainers = document.querySelectorAll('.avatar-photos');
    
    avatarContainers.forEach(container => {
        const images = Array.from(container.querySelectorAll('.avatar-photo'));
        
        if (images.length > 1) {
            // Fisher-Yates shuffle algorithm
            for (let i = images.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [images[i], images[j]] = [images[j], images[i]];
            }
            
            // Clear the container and append shuffled images
            container.innerHTML = '';
            images.forEach(img => container.appendChild(img));
        }
    });
}

// Function to add link icons to headings in Documentation tagged posts
function addDocumentationLinkIcons() {
    // Check if this is a Documentation tagged post
    if (!document.body.classList.contains('tag-documentation')) {
        return;
    }

    // Find all headings with IDs in the content area
    const headings = document.querySelectorAll('.gh-content h1[id], .gh-content h2[id], .gh-content h3[id], .gh-content h4[id], .gh-content h5[id], .gh-content h6[id]');
    
    headings.forEach(heading => {
        const headingId = heading.getAttribute('id');
        if (!headingId) return;

        // Create the link icon element
        const linkIcon = document.createElement('button');
        linkIcon.className = 'heading-link-icon';
        linkIcon.setAttribute('aria-label', 'Copy link to this section');
        linkIcon.setAttribute('title', 'Copy link to this section');
        linkIcon.innerHTML = `
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.72-1.71"></path>
            </svg>
        `;

        // Add click event to copy the link
        linkIcon.addEventListener('click', async (e) => {
            e.preventDefault();
            const currentUrl = window.location.origin + window.location.pathname;
            const sectionLink = `${currentUrl}#${headingId}`;
            
            // Store the original icon HTML
            const originalIcon = linkIcon.innerHTML;
            const originalTitle = linkIcon.getAttribute('title');
            
            try {
                await navigator.clipboard.writeText(sectionLink);
                
                // Change to check icon and show feedback
                linkIcon.innerHTML = `
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20,6 9,17 4,12"></polyline>
                    </svg>
                `;
                linkIcon.setAttribute('title', 'Link copied!');
                linkIcon.classList.add('copied');
                
                // Reset after 2 seconds
                setTimeout(() => {
                    linkIcon.innerHTML = originalIcon;
                    linkIcon.setAttribute('title', originalTitle);
                    linkIcon.classList.remove('copied');
                }, 2000);
            } catch (err) {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = sectionLink;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                
                // Change to check icon and show feedback
                linkIcon.innerHTML = `
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20,6 9,17 4,12"></polyline>
                    </svg>
                `;
                linkIcon.setAttribute('title', 'Link copied!');
                linkIcon.classList.add('copied');
                
                setTimeout(() => {
                    linkIcon.innerHTML = originalIcon;
                    linkIcon.setAttribute('title', originalTitle);
                    linkIcon.classList.remove('copied');
                }, 2000);
            }
        });

        // Make the heading container relative positioned and add the icon
        heading.style.position = 'relative';
        heading.appendChild(linkIcon);
    });
}
